
// ROUTES
require('modules/media-moderation/routes/media-moderation');

// CONTROLLERS
require('modules/media-moderation/controllers/media-moderation');
require('modules/media-moderation/controllers/list');

// SERVICES
require('modules/media-moderation/services/media-moderation');
require('modules/media-moderation/services/list');
require('modules/media-moderation/services/edit');
require('modules/media-moderation/services/delete');


angular.module('unica_media_moderation', [

	'infinite-scroll',
	'angular-confirm',
	'bootstrapLightbox',

	// ROUTES
	'unica_media_moderation.media_routes',

	// CONTROLLERS
	'unica_media_moderation.media_controllers',

	// SERVICES
	'unica_media_moderation.media_services'

]);